import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { workspaceActions, workspaceSelectors } from 'redux/workspace';

const useWorkspaceCover = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(workspaceActions.getWorkspaceProfile());
  }, [dispatch]);

  const workspaceProfile = useSelector(workspaceSelectors.getProfile);

  return workspaceProfile?.cover;
};

export default useWorkspaceCover;
